import React from 'react'
import { type DateRange } from 'react-day-picker'
import { useTranslation } from 'react-i18next'
import { Box, DatePicker, Input } from '@node-space/ui-components'
import { CardTransactionExport } from './CardTransactionExport/CardTransactionExport'

interface CardTransactionsFiltersProps {
  searchQuery: string
  onSearchChange: (value: string) => void
  dateRange: DateRange
  onDateRangeChange: (range: DateRange) => void
}

export const CardTransactionsFilters = ({
  searchQuery,
  onSearchChange,
  dateRange,
  onDateRangeChange,
}: CardTransactionsFiltersProps) => {
  const { t } = useTranslation()

  return (
    <Box width="full" flex isFlexWrap gapX={12} gapY={12}>
      <Box className="lg:flex-auto lg:min-w-[200px]">
        <Input
          value={searchQuery}
          testId="card-transaction-search-field"
          placeholder={t('customers.cardTransactionSearchPlaceholder')}
          searchable
          onChange={event => onSearchChange(event.target.value)}
        />
      </Box>
      <DatePicker
        mode="range"
        id="card-transaction-date-range"
        label=""
        placeholder={t('customers.cardTransactionDateRangePlaceholder')}
        initialSelected={dateRange}
        onSelect={onDateRangeChange}
      />
      <CardTransactionExport />
    </Box>
  )
}
